import axios from "axios";

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = (error) => reject(error);
  });
};

export const uploadImageToBlob = async (fullDataUri, fileName, imageType) => {

  const mimeMatch = fullDataUri.match(/^data:(image\/[a-z]+);base64,/);
  const actualMimeType = mimeMatch ? mimeMatch[1] : "image/jpeg";
  const base64 = fullDataUri.split(",")[1];

  const payload = {
    file: {
      uri: fullDataUri,
      mimetype: actualMimeType,
    },
    label: fileName,
    imageType,
  };


  try {
    const response = await axios.post("/user/upload-image", payload);
    return response;
  } catch (error) {
    // throw error;
  }
};

export const removeImageFromBlob = async (blobName) => {
  try {
    const response = await axios.delete("/remove-image", {
      data: {
        blobName,
      },
    });

    return response.data;
  } catch (error) {
    // throw error;
    return { success: false, message: "Failed to remove image" };
  }
};
